var map = {
	"./banner.jpg": 146,
	"./banner2.jpg": 845,
	"./banner3.jpg": 421,
	"./clothes.jpg": 346,
	"./cosmetic_1.jpg": 113,
	"./cosmetic_2.jpg": 332,
	"./cosmetic_3.jpg": 618,
	"./cosmetic_4.jpg": 293,
	"./faith-yarn-Wr0TpKqf26s-unsplash.jpg": 403,
	"./jacket.jpg": 6,
	"./jeans.jpg": 834,
	"./loreal-paris-logo.png": 986,
	"./shoes.jpg": 579,
	"./t-shirt.jpg": 876
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 173;